// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const STROLLER_ADD_REVIEW = "P\u0159idej hodnocen\u00ed";
export const STROLLER_MORE_REVIEWS = "Dal\u0161\u00ed hodnocen\u00ed";
export const STROLLER_NO_REVIEWS = "Zat\u00edm nikdo neohodnotil tento ko\u010d\u00e1rek";
export const STROLLER_REVIEWS_FROM_MOTHERS = "Hodnocen\u00ed maminek";
